import { ref, computed, watch, nextTick, type Ref } from 'vue';
import { useBrowserLocation } from '@vueuse/core';

export function useSettingsHash(): {
    hash: Ref<string>;
    content: Ref<HTMLElement | undefined>;
} {
    const location = useBrowserLocation();
    const hash = computed(() => location.value.hash?.replace('#/', '').replace('#', '') ?? '');

    const content = ref<HTMLElement>();
    watch(
        hash,
        async () => {
            await nextTick();
            if (!content.value || window.innerWidth >= 768) {
                return;
            }
            content.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        { immediate: true }
    );

    return { hash, content };
}
